import { Helmet } from 'react-helmet-async';
import { faker } from '@faker-js/faker';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container } from '@mui/material';
// sections
import { AppOrderTimeline, AppCurrentVisits, AppWebsiteVisits, AppWidgetSummary } from '../sections/@dashboard/app';

// ----------------------------------------------------------------------

const teamWidgets = {
  'SEO': [
    { title: "SEO Performance Analysis", total: 714000, icon: 'carbon:sales-ops' },
    { title: "Keyword Rankings", total: 1352831, color: "info", icon: 'mdi:chart-bar' },
    { title: "Backlinks Gained", total: 1723315, color: "warning", icon: 'mdi:link' },
    { title: "Organic Traffic", total: 234, color: "error", icon: 'mdi:web' }
  ],
  'Content Creation': [
    { title: "Content Production Status", total: 714000, icon: 'mdi:pen' },
    { title: "Articles Completed", total: 1352831, color: "info", icon: 'mdi:file-document' },
    { title: "Social Media Posts", total: 1723315, color: "warning", icon: 'mdi:instagram' },
    { title: "Blogs Published", total: 234, color: "error", icon: 'mdi:post' }
  ],
  'WebSite Designing': [
    { title: "Web Design Progress", total: 714000, icon: 'mdi:web' },
    { title: "Pages Developed", total: 1352831, color: "info", icon: 'mdi:file-code' },
    { title: "Bugs Fixed", total: 1723315, color: "warning", icon: 'mdi:bug' },
    { title: "New Features", total: 234, color: "error", icon: 'mdi:lightbulb-on' }
  ],
  'Camera Man': [
    { title: "Shoots Completed", total: 714000, icon: 'solar:camera-bold' },
    { title: "Videos Recorded", total: 1352831, color: "info", icon: 'mdi:video' },
    { title: "Equipment Checked", total: 1723315, color: "warning", icon: 'mdi:camera-burst' },
    { title: "Upcoming Shoots", total: 234, color: "error", icon: 'mdi:calendar' }
  ],
  'Video Editing': [
    { title: "Videos Edited", total: 714000, icon: 'mdi:video-edit' },
    { title: "Projects Completed", total: 1352831, color: "info", icon: 'mdi:check-circle' },
    { title: "Pending Reviews", total: 1723315, color: "warning", icon: 'mdi:clock' },
    { title: "Revisions Needed", total: 234, color: "error", icon: 'mdi:alert-circle' }
  ],
  'Graphic Designing': [
    { title: "Designs Created", total: 714000, icon: 'mdi:palette' },
    { title: "Social Media Graphics", total: 1352831, color: "info", icon: 'mdi:instagram' },
    { title: "Logo Designs", total: 1723315, color: "warning", icon: 'mdi:vector-square' },
    { title: "Branding Projects", total: 234, color: "error", icon: 'mdi:branding-watermark' }
  ],
  'Social Media': [
    { title: "Posts Managed", total: 825000, icon: 'mdi:post' },
    { title: "Engagement Rate", total: "4.8%", color: "info", icon: 'mdi:chart-line' },
    { title: "Followers Gained", total: 1523420, color: "warning", icon: 'mdi:account-group' },
    { title: "Campaigns Executed", total: 389, color: "error", icon: 'mdi:bullhorn' }
  ]
};

const teamChartData = {
  'SEO': {
    title: "SEO Performance Tracker",
    data: [
      {
        name: 'Keyword Rankings',
        type: 'column',
        fill: 'solid',
        data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
      },
      {
        name: 'Organic Traffic',
        type: 'line',
        fill: 'solid',
        data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
      }
    ]
  },
  'Content Creation': {
    title: "Content Production Tracker",
    data: [
      {
        name: 'Articles Written',
        type: 'column',
        fill: 'solid',
        data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
      },
      {
        name: 'Social Posts',
        type: 'line',
        fill: 'solid',
        data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
      }
    ]
  },
  'WebSite Designing': {
    title: "Web Development Progress",
    data: [
      {
        name: 'Pages Developed',
        type: 'column',
        fill: 'solid',
        data: [14, 25, 36, 30, 45, 35, 63, 52, 59, 36, 39],
      },
      {
        name: 'Bugs Fixed',
        type: 'line',
        fill: 'solid',
        data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
      }
    ]
  },
  'Camera Man': {
    title: "Shoot Progress",
    data: [
      {
        name: 'Shoots Completed',
        type: 'column',
        fill: 'solid',
        data: [14, 25, 36, 30, 45, 35, 63, 52, 59, 36, 39],
      },
      {
        name: 'Hours Recorded',
        type: 'line',
        fill: 'solid',
        data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
      }
    ]
  },
  'Video Editing': {
    title: "Editing Progress",
    data: [
      {
        name: 'Videos Edited',
        type: 'column',
        fill: 'solid',
        data: [14, 25, 36, 30, 45, 35, 63, 52, 59, 36, 39],
      },
      {
        name: 'Hours Worked',
        type: 'line',
        fill: 'solid',
        data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
      }
    ]
  },
  'Graphic Designing': {
    title: "Design Progress",
    data: [
      {
        name: 'Designs Created',
        type: 'column',
        fill: 'solid',
        data: [14, 25, 36, 30, 45, 35, 63, 52, 59, 36, 39],
      },
      {
        name: 'Projects Completed',
        type: 'line',
        fill: 'solid',
        data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
      }
    ]
  },
  'Social Media': {
    title: "Social Media Performance",
    data: [
      {
        name: 'Posts Published',
        type: 'column',
        fill: 'solid',
        data: [18, 24, 40, 35, 50, 42, 70, 55, 60, 38, 45],
      },
      {
        name: 'Engagement Rate (%)',
        type: 'line',
        fill: 'solid',
        data: [3.2, 4.0, 4.5, 3.8, 5.2, 4.9, 6.1, 5.8, 6.3, 4.7, 5.0],
      }
    ]
  }
};

const teamTimelineTitles = {
  'SEO': [
    'SEO audit completed',
    'Keyword research finalized',
    'Backlink analysis done',
    'Technical SEO implemented',
    'Content optimization finished'
  ],
  'Content Creation': [
    'Blog post published',
    'Social media content created',
    'Newsletter drafted',
    'Case study completed',
    'Whitepaper finalized'
  ],
  'WebSite Designing': [
    'Homepage redesign completed',
    'New feature implemented',
    'Bug fixes deployed',
    'Performance optimization done',
    'Mobile responsiveness improved'
  ],
  'Camera Man': [
    'Product shoot completed',
    'Interview recorded',
    'B-roll footage captured',
    'Studio session wrapped',
    'Location shoot finished'
  ],
  'Video Editing': [
    'Video edit finalized',
    'Color grading completed',
    'Sound mixing done',
    'Special effects added',
    'Final review completed'
  ],
  'Graphic Designing': [
    'Logo design approved',
    'Social media kit created',
    'Brochure layout finalized',
    'Brand guidelines updated',
    'Presentation deck designed'
  ],
  'Social Media': [
    'Scheduled posts for the week',
    'Engagement strategy updated',
    'Ad campaign performance reviewed',
    'Influencer collaboration finalized',
    'Monthly analytics report generated'
  ]
};

export default function ServiceDashboard() {
  const theme = useTheme();
  const serviceTeamType = sessionStorage.getItem("serviceTeamType");
  const currentTeam = serviceTeamType || 'SEO'; // Default to SEO if no team type

  return (
    <>
      <Helmet>
        <title> {currentTeam} Dashboard </title>
      </Helmet>

      <Container maxWidth="xl">
        <Grid container spacing={3}>
          {/* Team-specific widgets */}
          {teamWidgets[currentTeam]?.map((widget, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <AppWidgetSummary
                title={widget.title}
                total={widget.total}
                color={widget.color}
                icon={widget.icon}
              />
            </Grid>
          ))}

          {/* Team-specific chart */}
          <Grid item xs={12} md={12} lg={12}>
            <AppWebsiteVisits
              title={teamChartData[currentTeam]?.title || "Project Tracker"}
              subheader="Weekly performance metrics"
              chartLabels={[
                '01/01/2003',
                '02/01/2003',
                '03/01/2003',
                '04/01/2003',
                '05/01/2003',
                '06/01/2003',
                '07/01/2003',
                '08/01/2003',
                '09/01/2003',
                '10/01/2003',
                '11/01/2003',
              ]}
              chartData={teamChartData[currentTeam]?.data || []}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <AppCurrentVisits
              title="Task Status"
              chartData={[
                { label: 'Pending', value: 4344 },
                { label: 'Inprogress', value: 5435 },
                { label: 'Completed', value: 1443 },
                { label: 'Waiting', value: 4443 },
              ]}
              chartColors={[
                theme.palette.primary.main,
                theme.palette.info.main,
                theme.palette.warning.main,
                theme.palette.error.main,
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <AppOrderTimeline
              title="Recent Activities"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: teamTimelineTitles[currentTeam]?.[index] || `Activity ${index + 1}`,
                type: `order${index + 1}`,
                time: faker.date.past(),
              }))}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}